import './App.css';
import { Grid, Box } from '@mui/material'
import Header from './components/Header';
import WhiteCard from './components/WhiteCard';
import ImageSearch from './module/ImageSearch';
import Navigation from './components/Navigation';
import { ImageSearchContextProvider } from './components/ImageSearchQueryContext';

function App() {
  return (
    <>
      <Header />
      <Box
        bgcolor="#E6D6D1"
        pt={7}
        minHeight={{
          xs: "calc(100vh - 74px)",
          sm: "calc(100vh - 74px)",
          md: "calc(100vh - 56px)",
          lg: "calc(100vh - 56px)",
        }}
      >
        <Grid container justifyContent="center">
          <Grid item xs={11} sm={9} md={8} lg={7} sx={{width: '100%', margin: '24px 32px'}}>
            <ImageSearchContextProvider>
              <Navigation />
            <WhiteCard margin="2rem 0" mobMar="2rem 0">
              <Grid
                container
                direction='row'
                justifyContent='center'
                alignItems='center'
                lg={12}
                md={12}
                xl={9}
                
              >
                <Grid
                  item
                  lg={12}
                  md={12}
                  xl={12}
                  sx={{
                    width: "100%",
                    alignItems: "center",
                    borderRadius: '8px',
                    background: '#fff',
                    boxSizing: "border-box",
                  }}
                >
                  <ImageSearch/>

                </Grid>
              </Grid>
            </WhiteCard>
            </ImageSearchContextProvider>
           
          </Grid >
        </Grid >
      </Box>

    </>

  );
}

export default App;
